import React from "react";

/**
  Defines the clipping paths used for this layout.

    @note Paths created here:
    https://codesandbox.io/p/sandbox/bezier-curve-clip-path-forked-8jjylr?file=%2Findex.html%3A6%2C52
 */
export default function ClipPaths(): React.ReactElement {
    return (
        <svg
            width="0"
            height="0"
            style={{
                position: "absolute",
            }}
        >
            <defs>
                <clipPath
                    id="topAndBottom"
                    clipPathUnits="objectBoundingBox"
                >
                    <path d="M 0,.2 C .22 .2, .3 0 1,0 L 1,0 L 1,.77 C .75 .76, .55 .96,  0, 1 L 1,1 L 0,1 Z" />
                </clipPath>
                <clipPath
                    id="topAndBottomOld"
                    clipPathUnits="objectBoundingBox"
                >
                    <path d="M 0,.3 C .62 .3, .5 .1 1,0 L 1,0 L 1,.67 C .65 .66, .55 .96, 0, 1 L 1,1 L 0,1 Z" />
                </clipPath>
                <clipPath
                    id="topBox"
                    clipPathUnits="objectBoundingBox"
                >
                    <path d="M 0,.5 C .67 .4, .5 .1 1,0 L 1,0 L 1,1 L 0,1 Z" />
                </clipPath>
                <clipPath
                    id="bottomBox"
                    clipPathUnits="objectBoundingBox"
                >
                    <path d="M 0,1 L 0,0 L 1,0 L 1,.87 C .85 .86, .55 .96, 0, 1 0 1Z" />
                </clipPath>
                <clipPath
                    id="leftBoxInverted"
                    clipPathUnits="objectBoundingBox"
                >
                    <path d="M 0,0 L .7,0 Q .7,.4, 1,1 L 1,1 L 0,1 Z" />
                </clipPath>
                <clipPath
                    id="leftBox"
                    clipPathUnits="objectBoundingBox"
                >
                    <path d="M 0,0 L 1,0 L 1,1 L .2,1 Q 0,.5, 0,0 Z" />
                </clipPath>
            </defs>
        </svg>
    );
}
